import React from 'react';

import { IncrementIcon, DecrementIcon } from '@assets/icons';
import CustomIcon from '@components/utils/CustomIcon';

import {
  CounterButton,
  CounterButtonLabel,
  StyledCounter,
  TooltipStyle,
  TourIncrementButtonWrapper,
} from './CounterStyle';
import { CounterProps } from './CounterInterface';

const Counter = ({
  count = 0,
  min = 0,
  max = 0,
  handleIncrement = () => false,
  handleDecrement = () => false,
  disabledDecrement = false,
  disabledIncrement = false,
  tooltipMessage = '',
}: CounterProps) => {
  return (
    <StyledCounter>
      <CounterButton
        data-testid='decrement-button'
        disabled={disabledDecrement || count <= min}
        onClick={handleDecrement}
        type='button'
      >
        <CustomIcon
          icon={DecrementIcon}
          fontSize={24}
          paletteColor='darkGrey'
        />
      </CounterButton>
      <CounterButtonLabel data-testid='count-label'>{count}</CounterButtonLabel>
      <TooltipStyle
        placement='top'
        trigger='click'
        title={disabledIncrement ? tooltipMessage : ''}
        getPopupContainer={(triggerNode) => triggerNode}
      >
        <TourIncrementButtonWrapper>
          <CounterButton
            type='button'
            data-testid='increment-button'
            disabled={disabledIncrement || (max ? count >= max : false)}
            onClick={handleIncrement}
          >
            <CustomIcon
              icon={IncrementIcon}
              fontSize={24}
              paletteColor='darkGrey'
            />
          </CounterButton>
        </TourIncrementButtonWrapper>
      </TooltipStyle>
    </StyledCounter>
  );
};

export default Counter;
